import type {
  PortfolioProgressGroupResource,
  TaskProgressResource,
  TaskProgressStudentListResource,
} from "api/generated";
import type {
  TaskProgress,
  TaskProgressGroup,
  TaskProgressStudentListItem,
} from "portfolio/types";
import { portfolioShallowStudentFromDto } from "./portfolioShallowStudent.mapper";

const mapTaskProgressStudentListItem = (
  dto: TaskProgressStudentListResource,
): TaskProgressStudentListItem => ({
  activityId: dto.activity_id,
  student: portfolioShallowStudentFromDto(dto.student),
  completedAt: dto?.completed_at ? new Date(dto.completed_at) : null,
  submittedAt: dto.submitted_at ? new Date(dto.submitted_at) : null,
  assessedAt: dto.assessed_at ? new Date(dto.assessed_at) : null,
  status: dto.status,
  assessmentStatus: dto.assessment_status,
  gradeValue: dto.grade_value ?? null,
  assessedByShortage: dto.assessed_by_shortage ?? null,
  totalActivities: 0,
  totalSkills: 0,
  totalAttachments: 0,
  totalReferences: 0,
  meta: {
    canGrade: Boolean(dto.meta?.can_grade),
  },
});

const mapTaskProgressGroup = (
  dto: PortfolioProgressGroupResource,
): TaskProgressGroup => ({
  name: dto.name,
  studentAmount: dto.student_amount,
  completedAmount: dto.completed_amount,
});

export const taskProgressFromDto = (
  resource: TaskProgressResource,
): TaskProgress => ({
  groups: resource.groups.map(mapTaskProgressGroup),
  data: resource.data.map(mapTaskProgressStudentListItem),
  activeGroup: resource.activeGroup,
});
